export default "__VITE_ASSET__CM1s$hrs__"